import { FiGlobe, FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";
import RichTextDisplay from "components/common/RichTextDisplay";

function ContactRow({ icon: Icon, label, children }) {
  if (!children) return null;
  return (
    <div className="flex items-start gap-3">
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-text-500" />
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-wide text-text-500">{label}</p>
        <div className="mt-0.5 text-sm text-text-900">{children}</div>
      </div>
    </div>
  );
}

export default function CompanyOverviewTab() {
  const { project, tabContent } = useProjectDetailsContext();

  const hasContactInfo =
    project.companyWebsite ||
    project.companyEmail ||
    project.companyPhone ||
    project.companyHeadOfficeAddress;

  return (
    <div className="mt-3 space-y-6">
      {hasContactInfo && (
        <div className="grid gap-4 rounded-xl border border-slate-200 bg-slate-50/60 p-4 sm:grid-cols-2">
          <ContactRow icon={FiGlobe} label="Website">
            {project.companyWebsite && (
              <a
                href={project.companyWebsite}
                target="_blank"
                rel="noopener noreferrer"
                className="break-all text-brand-700 underline hover:text-brand-900"
              >
                {project.companyWebsite}
              </a>
            )}
          </ContactRow>

          <ContactRow icon={FiMail} label="Email">
            {project.companyEmail && (
              <a
                href={`mailto:${project.companyEmail}`}
                className="text-brand-700 underline hover:text-brand-900"
              >
                {project.companyEmail}
              </a>
            )}
          </ContactRow>

          <ContactRow icon={FiPhone} label="Phone">
            {project.companyPhone && (
              <a href={`tel:${project.companyPhone}`} className="hover:text-brand-700">
                {project.companyPhone}
              </a>
            )}
          </ContactRow>

          <ContactRow icon={FiMapPin} label="Head Office Address">
            {project.companyHeadOfficeAddress}
          </ContactRow>
        </div>
      )}

      {tabContent.companyOverview && (
        <RichTextDisplay html={tabContent.companyOverview} />
      )}

      {!hasContactInfo && !tabContent.companyOverview && (
        <p className="text-sm text-text-600">
          Company profile and legal details are being reviewed and will be shared here.
        </p>
      )}
    </div>
  );
}
